
export default {
  data() {
    return {
      is_mobile: window.innerWidth < 992,
      is_open: !(window.innerWidth < 992)
    }
  },
  head() {
    return {
      bodyAttrs: {
        class: this.is_open ? (this.is_mobile ? 'sidebar-mini layout-fixed layout-navbar-fixed sidebar-open' : 'sidebar-mini layout-fixed layout-navbar-fixed') : (this.is_mobile ? 'sidebar-mini layout-fixed layout-navbar-fixed sidebar-closed sidebar-collapse': 'sidebar-mini layout-fixed layout-navbar-fixed sidebar-collapse')
      }
    }
  },
  created() {
    this.$nuxt.$on('setIsOpen', (status) => {
      if (status !== undefined) {
        this.is_open = status
      } else {
        this.is_open = !this.is_open
      }
    })
  },
  methods: {
    closeSidebar() {
      this.is_open = false
    }
  }
}
